import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';

import { STATUS_VALUE_OPTIONS } from '../optionValues';

export const PRIORITY_OPTIONS_UA = [
  { value: 'High', label: 'Високий' },
  { value: 'Medium', label: 'Середній' },
  { value: 'Low', label: 'Низький' },
];

export const KEY_COMPETITORS_PRIORITY_OPTIONS_UA = [
  { value: 'High', label: 'Високий' },
  { value: 'Medium', label: 'Середній' },
  { value: 'Low', label: 'Низький' },
];

export const TERMS_OPTIONS_UA = [
  { value: 'longTerm', label: 'Довгостроковий' },
  { value: 'shortTerm', label: 'Короткостроковий' },
];

export const LIFE_CYCLE_STAGES_OPTIONS_UA = [
  { label: 'Ідея', value: 'Idea' },
  { label: 'Дослідження та розробка (R&D)', value: 'R&D' },
  { label: 'Зростання', value: 'Growth' },
  { label: 'Зрілість', value: 'Maturity' },
];

export const PROJECT_STATUS_OPTIONS_UA = [
  { value: 'Idea Assessment', label: 'Оцінка ідеї' },
  { value: 'Research and Development', label: 'Дослідження та розробка' },
  { value: 'Evaluation and Selection', label: 'Вибір стратегії' },
  { value: 'Financing', label: 'Фінансування' },
  { value: 'Implementation', label: 'Впровадження' },
  { value: 'Operation and Management', label: 'Операційна діяльність' },
];

export const FUNDING_DIRECTIONS_OPTIONS_UA = [
  {
    label: 'Дослідження та розробка (R&D)',
    value: 'Research and Development (R&D)',
  },
  { label: 'Маркетинг і збут', value: 'Marketing and Sales' },
  { label: 'Оборотний капітал', value: 'Working Capital' },
  {
    label: 'Будівництво та ремонт',
    value: 'Construction of Buildings and Facilities',
  },
  { label: 'Придбання обладнання', value: 'Purchase of Equipment' },
];

export const STATUS_OPTIONS_UA = [
  { value: STATUS_VALUE_OPTIONS.DONE, label: 'Виконано' },
  { value: STATUS_VALUE_OPTIONS.IN_PROGRESS, label: 'В процесі' },
  { value: STATUS_VALUE_OPTIONS.TO_DO, label: 'Заплановано' },
];

export const GENDER_OPTIONS_UA = [
  { value: 'Male', label: 'Чоловіча' },
  { value: 'Female', label: 'Жіноча' },
  { value: 'Gender-Neutral', label: 'Гендерно-нейтральна' },
];

export const PRODUCT_SERVICE_OPTIONS_UA = [
  { value: 'Product/Service', label: 'Продукт/Послуга' },
  { value: 'Region', label: 'Регіон' },
  { value: 'Market Segment', label: 'Ринковий сегмент' },
];

export const CONSUMER_OPTIONS_UA = [
  { value: 'Product', label: 'Продукт' },
  { value: 'Service', label: 'Послуга' },
  { value: 'Consumer', label: 'Споживач' },
  { value: 'Producer', label: 'Виробник' },
  { value: 'Other Market Segment', label: 'Інший ринковий сегмент' },
];

export const UNITS_VALUES_UA = {
  VOLUME_IN: 'Обсяг у',
  CURRENCY: 'Валюта',
} as const;

export const PREMISE_TERMS_OF_USE_OPTIONS_UA = [
  { value: 'Ownership', label: 'Право власності' },
  { value: 'Renting', label: 'Оренда' },
  { value: 'Leasing', label: 'Лізинг' },
  { value: 'Shared Ownership', label: 'Спільна власність' },
];

export const DELIVERY_TERMS_OPTIONS_UA = [
  { value: 'Prepayment', label: 'Передоплата' },
  { value: 'Upon delivery', label: 'Оплата при доставці' },
  { value: 'Deferred payment', label: 'Відстрочений платіж' },
];

export const RISKS_OPTIONS_UA = [
  { value: 'marketRisks', label: 'Ринкові ризики' },
  { value: 'operationalRisks', label: 'Операційні ризики' },
  { value: 'financialRisks', label: 'Фінансові ризики' },
  { value: 'legalAndRegulatoryRisks', label: 'Юридичні та регуляторні ризики' },
  { value: 'technologicalRisks', label: 'Технологічні ризики' },
  { value: 'humanResourceRisks', label: 'Кадрові (HR) ризики' },
  { value: 'environmentalRisks', label: 'Екологічні ризики' },
  { value: 'other', label: 'Інші' },
];

export const ONE_PAGE_OPTIONS_UA = [
  { label: 'Скорочений', value: BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT },
  { label: 'Розширений', value: BUSINESS_PLAN_TYPES.ONE_PAGE },
];

